import React from "react";
import ButtonBar from "../base/ButtonBar";
import AppConfig from "../../config/app";

function AssetLibraryFooter(props) {
  const alignment = AppConfig.demoMode ? "flex-end" : "space-between";
  return <ButtonBar align={alignment}>{props.children}</ButtonBar>;
}

export default AssetLibraryFooter;
